<application-about [environment]="candidateEnv"></application-about>
